import { render } from "./play.svg?vue&type=template&id=d5141b66"
const script = {}
script.render = render

export default script